import React from "react";
import { FaAddressBook } from "react-icons/fa";
import { BsFillPhoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { Ri24HoursFill } from "react-icons/ri";

function ContactAddress({ t }) {
  return (
    <>
      <div className="connectSec">
        <div className="row">
          <div className="col-lg-6">
            <div className="feature-box">
              <div className="feature-box-content">
                <BsFillPhoneFill />
                <h4>{t("Phone Number")}</h4>
                <p>
                  <a href={`tel:+91 9718278601`}>+91 9718278601</a>
                  <a href={`tel:+91 8535002460`}> +91 8535002460</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="feature-box">
              <div className="feature-box-content">
                <MdEmail />
                <h4>{t("E-mail Address")}</h4>

                <p className="m-0">
                  <a href="mailto:vincahorticulture@gmail.com">
                    vincahorticulture@gmail.com
                  </a>
                </p>
                <br />
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="feature-box">
              <div className="feature-box-content">
                <FaAddressBook />
                <h4>{t("Address")}</h4>
                <p>
                  G-86 First Floor, ANJS Plaza, Sarita Vihar Main Road, Behind
                  Kalindi Kunj Bus stop, Near Atlanticc water park, New Delhi
                  110025
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactAddress;
